// The product name, for copy that interpolates it.
//
// This used to be one of two axes resolved from the mount — a DESIGN axis choosing
// between two component trees, and this one choosing the displayed word. The design
// axis and its Orion tree are gone; there is one design. This survives as a single
// source for the name so copy keeps interpolating `{productName}` (see the i18n rule
// in CLAUDE.md) instead of baking the literal into 20 call sites.
export type ProductName = 'Symphony';

export function useProductName(): ProductName {
  return 'Symphony';
}
